import React from 'react';
import { Clock, ShieldIcon, BookOpenIcon } from 'lucide-react';
export function MechanismSection() {
  const steps = [{
    icon: <Clock className="w-8 h-8 text-gold" data-id="element-170" />,
    number: '1',
    title: 'Downshift',
    subtitle: '60–90 SECONDS',
    description: 'A discreet nervous-system reset you can do while kissing, touching, or stepping away for a moment.',
    purpose: 'stop your body from treating intimacy like a threat.'
  }, {
    icon: <ShieldIcon className="w-8 h-8 text-gold" data-id="element-171" />,
    number: '2',
    title: 'Re-Anchor',
    subtitle: 'ATTENTION CONTROL',
    description: 'A simple attention strategy that pulls you out of scoreboard thinking and back into sensation and connection.',
    purpose: 'break spectatoring in real time.'
  }, {
    icon: <BookOpenIcon className="w-8 h-8 text-gold" data-id="element-172" />,
    number: '3',
    title: 'No-Fail Ladder',
    subtitle: 'PROGRESSION',
    description: 'A progression that removes the single pass/fail moment.',
    purpose: "even if you wobble, you don't panic—because you already know what to do next."
  }];
  return <section id="solution" className="py-16 md:py-20 px-4 sm:px-6 relative" data-id="element-173">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-174"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-175">
        <div className="text-center mb-10" data-id="element-176">
          <h2 className="text-2xl md:text-3xl font-bold mb-2 text-gold" data-id="element-177">
            The Anti-Spiral Switch
          </h2>
          <p className="text-base md:text-lg text-text-primary font-medium mb-4" data-id="element-178">
            Downshift → Re-Anchor → No-Fail Ladder
          </p>
          <p className="text-sm text-text-secondary max-w-2xl mx-auto" data-id="element-179">
            It's not meditation. It's not positive psychology. It's not
            willpower. It's a field protocol for the exact moment you start
            monitoring yourself.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-180">
          {steps.map((step, index) => <div key={index} className="bg-[#151820] border border-[#2a2d3a] rounded-xl p-6 h-full flex flex-col" data-id="element-181">
              <div className="mb-4" data-id="element-182">{step.icon}</div>
              <h3 className="text-xl font-playfair font-bold text-text-primary mb-1.5" data-id="element-183">
                {step.number}) {step.title}
              </h3>
              <p className="text-gold text-xs font-bold tracking-[0.15em] mb-4 uppercase" data-id="element-184">
                {step.subtitle}
              </p>
              <p className="text-sm text-text-secondary leading-relaxed mb-5 flex-grow" data-id="element-185">
                {step.description}
              </p>
              <p className="text-sm text-text-primary leading-relaxed" data-id="element-186">
                <span className="font-bold" data-id="element-187">Purpose:</span> {step.purpose}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}